import { Card, CardBody, Col, ListGroup, ListGroupItem } from "reactstrap";
import { ProfileScrollableTitle } from "../../../constants";
import { ProfileScrollData, ProfileScrollSubTitle } from "../../../data/bonusUi/Scrollable";
import { dynamicImage } from "../../../utils";
import ScrollBar from "react-perfect-scrollbar";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { Image } from "../../../coreComponents/Image";

const ProfileScrollable = () => {
  return (
    <Col xxl="4" md="6">
      <Card>
        <CommonCardHeader title={ProfileScrollableTitle} span={ProfileScrollSubTitle} />
        <CardBody>
          <ScrollBar className="scroll-demo scroll-b-none custom-container">
            <ListGroup>
              {ProfileScrollData &&
                ProfileScrollData.map((item, index) => (
                  <ListGroupItem action className="list-hover-primary" key={index}>
                    <Image className="rounded-circle" src={dynamicImage(`user/${item.image}`)} alt="user" />
                    {item.text}
                  </ListGroupItem>
                ))}
            </ListGroup>
          </ScrollBar>
        </CardBody>
      </Card>
    </Col>
  );
};
export default ProfileScrollable;
